{
  "api": {
    "locationValidationTitle": "我們無法驗證您的位置",
    "thresholdTitle": "不在可報到的時間內",
    "warehouseUnavailableTitle": "倉庫目前無法使用",
    "warehouseUnavailableMessage": "請聯絡設施人員以進行人工報到",
    "characterLimitTitle": "輸入內容超過字元限制",
    "genericTitle": "報到失敗，請再試一次。",
    "recaptchaTitle": "驗證失敗",
    "recaptchaMessage": "我們無法驗證您的請求，請再試一次或聯絡設施人員。"
  }
}
